document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.collection-editorial__nav-viewport').forEach((viewport) => {
    const activeLink = viewport.querySelector('.collection-editorial__nav-link.is-active');

    if (!activeLink || viewport.scrollWidth <= viewport.clientWidth) return;

    requestAnimationFrame(() => {
      const previousLink = activeLink.previousElementSibling;
      const anchorLink = previousLink instanceof HTMLElement ? previousLink : activeLink;
      const targetLeft = Math.max(0, anchorLink.offsetLeft + 12);

      viewport.scrollTo({
        left: targetLeft,
        behavior: 'auto'
      });
    });
  });

  document.querySelectorAll('[data-nav-arrow]').forEach((arrow) => {
    const frame = arrow.closest('.collection-editorial__nav-frame');
    if (!frame) return;
    const viewport = frame.querySelector('.collection-editorial__nav-viewport');
    if (!viewport) return;

    arrow.addEventListener('click', () => {
      viewport.scrollBy({ left: 120, behavior: 'smooth' });
    });
  });

  document.querySelectorAll('[data-collection-load-more]').forEach((button) => {
    const section = button.closest('.collection-editorial__traditional--mobile');
    const grid = section?.querySelector('[data-collection-grid]');

    if (!section || !grid) return;

    button.addEventListener('click', () => {
      const batchSize = Number(button.getAttribute('data-batch-size')) || 6;
      const hiddenItems = Array.from(grid.querySelectorAll('[data-collection-grid-item].is-hidden'));

      hiddenItems.slice(0, batchSize).forEach((item) => {
        item.classList.remove('is-hidden');
      });

      if (grid.querySelectorAll('[data-collection-grid-item].is-hidden').length === 0) {
        button.hidden = true;
      }
    });
  });
});
